import React from 'react';
import styled from 'styled-components';

import Header from '~components/graphics/Header';
import Navigation from '~components/graphics/Navigation';
import MonumentInfo from '~components/graphics/MonumentInfo';

const SidebarStyles = styled.div`
  // background-color: rgba(255,255,255,0.9);
  background: #EEF5FD;
	padding-top: 24px;
  padding-bottom: 24px;
	width: 500px;
  z-index: 99;
  // position: absolute;
  // padding-top: 60px;
  padding-top: 54px;

  @media (max-width: 768px) {
    width: 100%;
    padding-bottom: 0;
  }
`;

const MonumentInfoStyles = styled.div`
  padding: 24px;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-end: 1;
  grid-row-end: 2;
  border: 1px solid #979797;
  background: #fff;
  overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  // height: calc(100vh - 347px);
  // height: calc(100vh - 338px);
  height: calc(100vh - 332px);
  z-index: 999;
  line-height: 1;
  margin-left: 24px;
  margin-right: 24px;

  .monument__desc {
    font-family: "Georgia";
    line-height: 1.6;
    // margin-top: 16px;
    color: #212121;
    // margin-bottom: 16px;

    p {
      margin-bottom: 24px;

      span {
        text-transform: uppercase;
        font-weight: 700;
        font-family: "Benton";
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 768px) {
    left: 0;
    border: none;
    height: auto;
    width: 100%;
    overflow-y: initial;
    padding: 24px;
    margin-left: 0;
    margin-right: 0;
  }
`;

const MonumentInline = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Sidebar = ({data}) => {
  return (
    <SidebarStyles>
    	<Header />
    	<Navigation data={data} />

      <MonumentInline>
        <img
          src="https://apps.bostonglobe.com/opinion/graphics/2022/05/covid-memorial/images/main_intro.jpg"
          alt="How do we memorialize the pandemic?"
        />
      </MonumentInline>

      <MonumentInfoStyles>
        <div className="monument__desc">
          <p><span>Throughout the COVID-19 pandemic</span>, temporary memorials have paid tribute to those lives claimed by the virus. They serve as quiet places to mourn loved ones and a chance to comprehend the enormity of the pandemic — more than 6 million dead worldwide.</p>
          <p>As the United States nears its one millionth COVID-19-related death, artists, architects, and community leaders are calling for a permanent memorial to honor all those touched by COVID and to ensure their pain is never forgotten. Fully realizing the pandemic is far from over, Globe Opinion asked several artists for their vision of what a COVID memorial could look like.</p>
          <a href="https://2cwk6j2ccxm.typeform.com/to/VdVpJEmc">Which monument do you think best represents this moment?</a>
       </div>
     </MonumentInfoStyles>
    </SidebarStyles>
  );
};

export default Sidebar;
